export default (context, video) => {
    let button = document.getElementById('player-component__button')
    let text = document.getElementById('player-component__text')
    let music = document.getElementById(`${context.music.id}`)
    let animDuration = 0;


    let setSource = () => {
        let videos = [
            {
                url: context.videos[context.position.playing].webm,
                type: 'video/webm'
            },
            {
                url: context.videos[context.position.playing].video,
                type: 'video/mp4'
            }
        ]

        for(let i = 0; i < 2; i++) {
            video.children[i].setAttribute('type', videos[i].type)
            video.children[i].src = videos[i].url
        }

        video.load()

    }

    let chnageFlags = (is_access) => {
        context.access_play = is_access
        context.is_ready_play = false
        animDuration = 0;
        text.style.animation = 'none'
    }

    let playNext = async () => {
        chnageFlags(true)
        context.position.playing++
        setSource()
    }

    let videoEnded = async () => {
        chnageFlags(false)
        if(music) { music.pause(), music.currentTime = 0 }
        video.pause()
        button.style.display = 'block'
        context.position.playing = 0
        setSource()
        context.$store.dispatch('timer/setCurrentDuration', {
            time: 0
        })
    }


    video.addEventListener('playing', () => {
        if(context.videos[context.position.playing].descr) {
            text.innerHTML = context.videos[context.position.playing].descr
            text.style.color = context.videos[context.position.playing].color
            text.style.animationPlayState = 'running'
            let time = context.videos[context.position.playing].descr.length > 3 ? context.videos[context.position.playing].descr.length : 3
            let width = text.getBoundingClientRect().width
            let allDurationAnim = context.videos[context.position.playing].speedText * time

            document.documentElement.style.setProperty('--textMargin', `-${width + (width / 20)}px`)
            text.style.animation = `text-rotate ${allDurationAnim}s linear`

            allDurationAnim = allDurationAnim * 1000

            context.interval = setInterval(() => {
                context.$store.dispatch('timer/setCurrentDuration', {
                    time: context.currentDuration + 100
                })
                if ((allDurationAnim - animDuration) <= 10) {
                    clearInterval(context.interval)
                    if(context.videos[context.position.playing + 1]) {
                        playNext()
                    } else {
                        videoEnded()
                    }
                } else {
                    animDuration = animDuration + 100
                }
            }, 100)
        } else {
            context.interval = setInterval(() => {
                context.$store.dispatch('timer/setCurrentDuration', {
                    time: context.currentDuration + 100
                })
                if((video.duration * 10) - (video.currentTime * 10) <= 10) {
                    clearInterval(context.interval)
                    if(context.videos[context.position.playing + 1]) {
                        playNext()
                    } else {
                        videoEnded()
                    }
                }
            }, 100)
        }
    })

    video.addEventListener('pause', () => {
        if(context.interval) clearInterval(context.interval)
        if(context.videos[context.position.playing].descr) {
            text.style.animationPlayState = 'paused'
        }
    })

    video.addEventListener('error', () => {
        console.error(video.error)
    })

    video.addEventListener('canplaythrough', () => {
        context.is_ready_play = true
        if(context.access_play) {
            video.play()
        } else {
            button.style.display = 'block'
        }
    })

}